import { createContext, useEffect, useState } from "react";
import { Button } from "../components/ui/button";
import { Sheet, SheetClose, SheetContent } from "../components/ui/sheet";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useAuth from "../hooks/useAuth";
import { useQuery } from "@tanstack/react-query";
import axios from "../lib/axios";
import { Skeleton } from "../components/ui/skeleton";
import { getCookie } from "../lib/cookies";

const DepartmentContext = createContext<null>(null);

export const DepartmentProvider = ({ children } : { children:React.ReactNode}) => {
    const {t, i18n} = useTranslation()
    const {auth} = useAuth()
    const location = useLocation()
    const navigate = useNavigate()
    const [open_sheet, setopen_sheet] = useState(false);

    const departmentActive = Boolean(auth?.data?.m_oDepartment?.m_bActive);
    const partnerName = auth?.data?.m_oPartner?.m_sName ?? "";
    const partnerId = auth?.data?.m_oPartner?.m_iPartnerID ?? null;
    const popupText = departmentActive ? t("explanation.o_department.popup") : t("explanation.o_department.popupActive");

    useEffect(()=>{
        if(auth.status === 'authenticated' && !location.pathname.includes('uitnodiging')){
            if(auth.data.m_oDepartment){
                if(auth.data.m_oDepartment.m_iPartnerID > 0 && auth.data.m_oDepartment.m_bActive){}
                else {
                    setopen_sheet(true)
                    return;
                }
            } else { setopen_sheet(true); return; }
        } else { setopen_sheet(false) }
    }, [location.pathname, auth.status])

    const { data:url, isLoading } = useQuery<string | null>({
        queryKey: [`get_invitation`],
        queryFn: async () => {
            try {
                const { data } = await axios.get(`get/invitation`)
                return data
            } catch (error) {
                console.log(error)
                return null
            }
        },
        enabled: open_sheet
    })

    const cookieInvite = getCookie('invitation-url')
    const language = (i18n.language || 'nl').toLowerCase()
    const normalizeInviteUrl = (rawUrl?: string | null) => {
        if (!rawUrl) { return null }
        const trimmed = rawUrl.startsWith('/') ? rawUrl : `/${rawUrl}`
        if (trimmed.includes('uitnodiging')) {
            return trimmed.startsWith('/inv/') ? trimmed : `/inv${trimmed}`
        }
        if (!partnerName) { return trimmed }
        const tokenOnly = !trimmed.slice(1).includes('/')
        if (tokenOnly && partnerId) {
            return `/uitnodiging/${partnerName}/${partnerId}${trimmed}`
        }
        return `/uitnodiging/${partnerName}${trimmed}`
    }
    const cookieUrl = (cookieInvite && cookieInvite.includes('uitnodiging')) ? cookieInvite : normalizeInviteUrl(url)

    console.log(cookieUrl)

    const isExternalInvite = Boolean(cookieUrl && /^https?:\/\//i.test(cookieUrl))
    const handleInviteClick = () => {
        if (!cookieUrl) { return }
        if (isExternalInvite) {
            window.location.assign(cookieUrl)
            return
        }
        navigate(cookieUrl)
    }

    return (
        <DepartmentContext.Provider value={null}>
            
            {children}

            <Sheet open={open_sheet}>
                <SheetContent className="mb-4 -translate-x-1/2 w-fit h-fit left-1/2 rounded-xl bg-tifo border-tifo-light" position="bottom" hideClose>
                    <div className="flex items-center gap-4 text-sm text-white">
                        <div>
                            <p className="max-w-sm">{popupText}</p>
                        </div>
                        {(isLoading) ? <Skeleton className="w-[150px] h-[40px] rounded-full"/>
                        : (cookieUrl && <button
                            type="button"
                            onClick={handleInviteClick}
                            className="h-10 px-4 font-medium duration-200 border rounded-full bg-white/20 hover:bg-white/30 whitespace-nowrap"
                        >
                            {t("explanation.o_department.title")}
                        </button>
                        )}
                    </div>
                </SheetContent>
            </Sheet>
        </DepartmentContext.Provider>
    )
}

export default DepartmentContext;
